import {AltDTO} from "../altDTO.interface";

export class AltMaintListDTO {
  id?: number;
  vehicleTypeId?: number;
  value: string;
  statusId?: number;
  alts?: AltDTO[];
}
